// extracted by mini-css-extract-plugin
module.exports = {"listStyles":"listComponent_listStyles__2yhij","listHr":"listComponent_listHr__1A8US","pHeader":"listComponent_pHeader__37uA0","listInfo":"listComponent_listInfo__faRLa"};